import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '@/app/routes';
import { LoadingOverlay } from '@/components/feedback';
import { useTranslations } from '@/hooks';
import { useCreateOrderMutation } from '../api/ordersApi';
import { OrderForm, EMPTY_ORDER_FORM } from '../components/OrderForm';
import { useOrderFormOptions } from '../hooks';

// Outbounds ▸ Orders ▸ Add.
export const AddOrderPage = () => {
  const t = useTranslations();
  const navigate = useNavigate();
  const { module } = useParams();

  const { options, sites, materials, getEquivalentUnit, isLoading } = useOrderFormOptions();
  const [createOrder, { isLoading: isSubmitting }] = useCreateOrderMutation();

  const goToOrders = useCallback(() => {
    navigate(ROUTES.orders(module));
  }, [navigate, module]);

  const handleSubmit = useCallback(
    async (values) => {
      const result = await createOrder({
        module,
        values,
        equivalentUnit: getEquivalentUnit(values),
      });
      if (result.error) return;
      goToOrders();
    },
    [createOrder, module, getEquivalentUnit, goToOrders],
  );

  // Wait for the dropdowns: <Form> seeds initialValues once, on mount.
  if (isLoading) {
    return <LoadingOverlay label={t('COMMON_LOADING')} />;
  }

  return (
    <OrderForm
      title={t('ORDERS_ADD')}
      submitLabel={t('COMMON_SAVE')}
      initialValues={EMPTY_ORDER_FORM}
      options={options}
      sites={sites}
      materials={materials}
      onSubmit={handleSubmit}
      onClose={goToOrders}
      isSubmitting={isSubmitting}
    />
  );
};
